import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useUserName from "../../common/hooks/useUserName";

import { posTableAPI } from "../../api/posTablesAPI";
import POSTablesImg from "../../assets/images/tables.png";

import Spinner from "../../components/spinner/spinner";

import "./posTables.css";

export default function POSTables() {
    const [isProcessing, setIsProcessing] = useState(false);
    const [tables, setTables] = useState([]);
    const [activeCategory, setActiveCategory] = useState("");

    const { userName } = useUserName();

    // Fetch tables
    useEffect(() => {
        setIsProcessing(true);
        posTableAPI
            .getPOSTables()
            .then((data) => setTables(data))
            .finally(() => setIsProcessing(false));
    }, []);

    // Group tables by category
    const groupedTables = tables.reduce((acc, t) => {
        (acc[t.category] ||= []).push(t);
        return acc;
    }, {});

    // Set default active tab
    useEffect(() => {
        const categories = Object.keys(groupedTables);
        if (categories.length && !activeCategory) {
            setActiveCategory(categories[0]);
        }
    }, [tables]);

    return (
        <>
            <div className="text-center">
                {isProcessing && <Spinner />}
            </div>

            {!isProcessing && (
                <div className="row">
                    <div className="col-12 posTable__div">

                        {/* Tabs */}
                        <ul className="nav nav-tabs mb-3">
                            {Object.keys(groupedTables).map((category) => (
                                <li className="nav-item" key={category}>
                                    <button
                                        type="button"
                                        className={`nav-link ${activeCategory === category ? "active" : ""
                                            }`}
                                        onClick={() => setActiveCategory(category)}
                                    >
                                        {category}
                                    </button>
                                </li>
                            ))}
                        </ul>

                        {/* Tab Content */}
                        <div className="tab-content">
                            {Object.entries(groupedTables).map(([category, items]) => (
                                <div
                                    key={category}
                                    className={`tab-pane fade ${activeCategory === category ? "show active" : ""
                                        }`}
                                >
                                    <div className="d-flex flex-wrap gap-3">
                                        {items.map((data) => (
                                            <Link
                                                to="/postouch"
                                                key={data.tableNo}
                                                state={{
                                                    selectedTableNo: data.tableNo,
                                                    backNavigationPath: "/steward/mainmenu",
                                                    selectedMode: "Steward - " + userName
                                                }}
                                            >
                                                <div
                                                    className={
                                                        "card posTables__card pb-0 " +
                                                        (data.isOccupied
                                                            ? "posTables__card--occupied"
                                                            : "")
                                                    }
                                                >
                                                    <img
                                                        className="card-img-top posTables__img"
                                                        src={POSTablesImg}
                                                        alt="Table"
                                                    />
                                                    <div className="card-body p-0 text-center">
                                                        <p className="card-title p-0 m-0">
                                                            Table # {data.tableNo}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            )}
        </>
    );
}
